import { IDropdownOption } from 'office-ui-fabric-react';

export let CONTROL_TYPES: IDropdownOption[] = [];

CONTROL_TYPES.push({key: 'Textbox', text: 'Textbox'});

export let addControlType = (controlType: IDropdownOption): void => {
	CONTROL_TYPES.push(controlType);
};


// WEBPACK FOOTER //
// ./source/ts/constants/options.ts